export default __webpack_public_path__ + "assets/CeraPro-Bold.otf";